interface StatusBadgeProps {
  status: 'O' | 'C' | 'R' | string;
}

const statusConfig: Record<string, { label: string; className: string }> = {
  O: {
    label: 'Open',
    className: 'bg-green-100 text-green-800',
  },
  C: {
    label: 'Closed',
    className: 'bg-gray-100 text-gray-600',
  },
  R: {
    label: 'Reopened',
    className: 'bg-yellow-100 text-yellow-800',
  },
};

export default function StatusBadge({ status }: StatusBadgeProps) {
  const config = statusConfig[status] ?? {
    label: status,
    className: 'bg-slate-100 text-slate-600',
  };

  return (
    <span
      className={`inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium ${config.className}`}
    >
      {config.label}
    </span>
  );
}
